import { RoomUser } from '../chat-component/interfaces';

import { GetDisplayableParticipantInput } from './interfaces';

export const getDisplayableParticipant = (input: GetDisplayableParticipantInput): RoomUser => {
  const { participant, userIdentity, isOnline } = input;
  const user: RoomUser = {
    _id: userIdentity ?? participant.sid,
    username: participant.identity!,
    avatar: '',
    status: {
      state: isOnline === true ? 'online' : 'offline',
      lastChanged: '',
    },
  };

  return user;
};
